module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-6-a4e35f3e0e48cb51f72704bb94495d61.svg";